<template>
  <slot
    v-if="loading"
    name="skeleton"
  >
    <Skeleton v-bind="props" />
  </slot>

  <slot v-else />
</template>

<script setup lang="ts">
  import Skeleton from './Skeleton.vue';

  const props = defineProps<{
    loading?: boolean;
    skeletonClass?: string;
    width?: number | string;
    height?: number | string;
  }>();

  defineSlots<{
    default(): unknown;
    skeleton(): unknown;
  }>();
</script>
